module.exports = __webpack_public_path__ + "static/img/图层 512.ec9aeb40.png";